var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEndDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#385963",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.707,15.293a1,1,0,0,0-1.414,0L19.5,18.086l-2.793-2.793a1,1,0,0,0-1.414,1.414L18.086,19.5l-2.793,2.793a1,1,0,1,0,1.414,1.414L19.5,20.914l2.793,2.793a1,1,0,0,0,1.414-1.414L20.914,19.5l2.793-2.793A1,1,0,0,0,23.707,15.293Z M12,22A10,10,0,1,1,22,12a1,1,0,0,0,2,0A12,12,0,1,0,12,24a1,1,0,0,0,0-2Z M12,6a1,1,0,0,0-1,1v4.586L8.293,14.293a1,1,0,1,0,1.414,1.414l3-3A1,1,0,0,0,13,12V7A1,1,0,0,0,12,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEndDate);
export default __webpack_public_path__ + "static/media/calendar-end-date.995fb3cc75e53c283918cf80491068da.svg";
export { ForwardRef as ReactComponent };